import { render, staticRenderFns } from "./HoldingPnr.vue?vue&type=template&id=00fae63a&scoped=true&"
import script from "./HoldingPnr.vue?vue&type=script&lang=js&"
export * from "./HoldingPnr.vue?vue&type=script&lang=js&"
import style0 from "./HoldingPnr.vue?vue&type=style&index=0&id=00fae63a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fae63a",
  null
  
)

export default component.exports